'use client'

import React, { useEffect, useState } from 'react'
import { Button } from '@/components/Button'
import { acceptCookies, hasCookieChoice, rejectCookies } from '@/lib/client/cookies'

export default function CookieConsent() {
  const [show, setShow] = useState(false)

  function accept() {
    acceptCookies()
    setShow(false)
  }

  function reject() {
    rejectCookies()
    setShow(false)
  }

  useEffect(() => {
    setShow(!hasCookieChoice())
  }, [])

  return show ? (
    <div
      className={
        'fixed w-full bottom-0 p-2 flex gap-2 bg-black text-white items-center justify-center z-[50]'
      }
    >
      Mag JeugdFilms.nl cookies plaatsen om de website en je ervaring te optimaliseren?
      <Button size={'sm'} onClick={accept}>
        Ja
      </Button>
      <Button size={'sm'} variant={'secondary'} onClick={reject}>
        Nee
      </Button>
    </div>
  ) : null
}
